<template>
  <div class="flex flex-col min-h-full">
    <topbar title="Iscriviti" :menu="false" :showBack="true" @back="$router.push({name: 'AuthStart'})" />
    <div class="flex flex-col justify-center flex-1 p-3 mx-auto max-w-2xl w-full ">
      <div class="flex flex-col">
        <input class="inp flex-1 p-2 my-2" :class="{faulty: faultyEmail}" type="email" v-model="email" :placeholder="$t('form.email.placeholder')">
        <input class="inp flex-1 p-2 my-2" type="password" v-model="password" :placeholder="$t('form.password.placeholder')">
        <div v-if="error" class="text-red-600 my-2">
          ⚠ {{ $t(`error.${error}`) }}
        </div>

        <button class="btn btn-1 my-2" @click="register">{{$t('continue')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: null,
      email: '',
      password: '',
      faultyEmail: false
    }
  },
  computed: {
    credentials() {
      return {
        email: this.email,
        password: this.password
      }
    }
  },
  methods: {
    async register() {
      this.error = null
      this.faultyEmail = false
      try {
        await this.$store.dispatch('registerEmailUser', this.credentials)
        this.$router.push({name: 'EmailVerification'})
      } catch(e) {
        this.error = e.code
        if(e.code == 'auth/email-already-in-use') {
          this.faultyEmail = true
        }
      }
    },
  }
}
</script>

<style>

</style>